import * as THREE from 'three'
var TWEEN = require('@tweenjs/tween.js')
var envmap = (function () {
    ///
  var camera, cubeCamera, scene, renderer
  var cube, cube2, cube3, mesh
  var currentTexture
  var warping = false
  var fov = 100
  var lon = 0
  var lat = 0
  var phi = 0
  var theta = 0
  var basedir
  var texture
  var params = {
    lon: 0.15,
    phi: 90,
    x: 100,
    y: 100,
    z: 400
  }

  function create (_basedir) {
    basedir = _basedir
            /*
            texture = THREE.ImageUtils.loadTexture(basedir + '/0.jpg',function () {
                init()
                animate()
                currentTexture = basedir + '/0.jpg'
                texture.needsUpdate = true;
                warpOut()
            })
            */
    var loader = new THREE.TextureLoader()
    loader.load(basedir + '/0.jpg', function (_texture) {
      init()
      animate()
      texture = _texture
      currentTexture = basedir + '/0.jpg'
      _texture.needsUpdate = true
      mesh.material.needsUpdate = true
      mesh.material.map = _texture
      warpOut()
    },
            // Function called when download progresses
            function (xhr) {
                // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            // Function called when download errors
            function (xhr) {
                //  console.log('An error happened');
            })
  }

  function init () {
    camera = new THREE.PerspectiveCamera(fov, window.innerWidth / window.innerHeight, 1, 1100)
    scene = new THREE.Scene()
    var mat = new THREE.MeshBasicMaterial()
    var geo = new THREE.SphereGeometry(500, 60, 40)
    mesh = new THREE.Mesh(geo, mat)
    mesh.material.map = texture
    mesh.material.side = THREE.DoubleSide
    mesh.scale.x = -1
    scene.add(mesh)
    renderer = new THREE.WebGLRenderer({
      antialias: true
    })
    renderer.setSize(window.innerWidth, window.innerHeight)
    cubeCamera = new THREE.CubeCamera(1, 1000, 256)
    cubeCamera.renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter
    scene.add(cubeCamera)
    document.body.appendChild(renderer.domElement)
    renderer.domElement.id = 'renderer'
    var material = new THREE.MeshBasicMaterial({
      envMap: cubeCamera.renderTarget
    })
            // document.addEventListener('mousedown', onDocumentMouseDown, false)
            // document.addEventListener('mousewheel', onDocumentMouseWheel, false)
            // document.addEventListener('DOMMouseScroll', onDocumentMouseWheel, false)
    document.addEventListener('mousemove', onDocumentMouseMove, true)
    window.addEventListener('resize', onWindowResized, false)
    onWindowResized(null)
  }
    /// ///EVENTS
  function onWindowResized (event) {
    renderer.setSize(window.innerWidth, window.innerHeight)
    camera.fov = fov
    // camera.projectionMatrix.makePerspective(fov, window.innerWidth / window.innerHeight, 1, 1100)
  }

  function onDocumentMouseDown (event) {
    event.preventDefault()
    onPointerDownPointerX = event.clientX
    onPointerDownPointerY = event.clientY
    onPointerDownLon = lon
    onPointerDownLat = lat
    document.addEventListener('mouseup', onDocumentMouseUp, true)
  }

  var stillTime = null
  var still = true

  function onDocumentMouseMove (event) {
    lon = (event.clientX) * 0.1
    lat = (event.clientY) * 0.1
    clearTimeout(stillTime)
    still = false
    stillTime = setTimeout(function () {
      still = true
    }, 100)
  }

  function setParams (_param) {
    params = _param
  }

  function animate (time) {
    requestAnimationFrame(animate)
    render()
    TWEEN.update(time)
  }

  function changeTexture (_index) {
    var loader = new THREE.TextureLoader()
    loader.load(basedir + '/' + _index + '.jpg', function (_texture) {
      texture = _texture
      texture.needsUpdate = true
      if (currentTexture != _index) {
        mesh.material.needsUpdate = true
        mesh.material.map = _texture
        _texture.needsUpdate = true
        currentTexture = _index
      }
    },
            // Function called when download progresses
            function (xhr) {
                //   console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            // Function called when download errors
            function (xhr) {
                //  console.log('An error happened');
            })
  }

  function render () {
    var time = Date.now()
    if (warping && still) {
      lon += params.lon
    }
    lat = Math.max(-85, Math.min(85, lat))
    phi = THREE.Math.degToRad(params.phi - lat)
    theta = THREE.Math.degToRad(lon)
    camera.position.x = params.x * Math.sin(phi) * Math.cos(theta)
    camera.position.y = params.y * Math.cos(phi)
    camera.position.z = params.z * Math.sin(phi) * Math.sin(theta)
    camera.lookAt(scene.position)
    cubeCamera.update(renderer, scene)
    renderer.render(scene, camera)
  }
  var param = {
    fov: 130
  }

  function warpIn () {
    var tween = new TWEEN.Tween(param).easing(TWEEN.Easing.Cubic.InOut).to({
      fov: 100
    }, 3000).onUpdate(function () {
      camera.fov = param.fov
      camera.updateProjectionMatrix()
      // camera.projectionMatrix.makePerspective(param.fov, window.innerWidth / window.innerHeight, 1, 1100)
    }).onStart(function () {
      warping = true
    }).onStop(function () {
      warping = false
    }).start()
  }

  function warpOut () {
    var tween = new TWEEN.Tween(param).easing(TWEEN.Easing.Cubic.InOut).to({
      fov: 179
    }, 3000).onUpdate(function () {
      camera.fov = param.fov
      camera.updateProjectionMatrix()
      // camera.projectionMatrix.makePerspective(param.fov, window.innerWidth / window.innerHeight, 1, 1100)
    }).onStart(function () {
      warping = true
    }).onStop(function () {
      warping = false
    }).start()
  }
    ///
  return {
    warpOut: warpOut,
    warpIn: warpIn,
    changeTexture: changeTexture,
    create: create,
    setParams: setParams
  }
    /// 
}())

export default envmap
